<template>
  <div>
    <div class="top_div">
      <img class="home_banner" :src="bgImg" />
      <div class="div_top_title">
        <p>资讯中心</p>
        <p class="p_title_sub">INFORMATION CENTER</p>
      </div>
    </div>
    <div class="html_div">
      <p class="title">{{ Detail.title }}</p>
      <p class="time">发布时间：{{ Detail.time }}</p>
      <p class="line"></p>
      <div class="content" v-html="Detail.content"></div>

      <p class="line"></p>
      <div class="news_more">
        <p @click="navto(prveNewsId)">【上一篇：{{ prveNewsTitle }}】</p>
        <p @click="goback()">【返回列表】</p>
        <p @click="navto(nextNewsId)">【下一篇：{{ nextNewsTitle }}】</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bgImg: "",
      prveNewsTitle: "",
      prveNewsId: "",
      nextNewsTitle: "",
      nextNewsId: "",
      Detail: {},
      NewsList: [
        {
          cover: "",
          time: "",
          title: "",
          simpleContent: "",
        },
      ],
    };
  },
  components: {},
  mounted() {
    this.Init();
  },
  watch: {
    $route(to, from) {
      console.log(to.path);
      this.Init();
    },
  },
  methods: {
    Init() {
      this.getBgImg();
      this.getDetail();
      this.getNews();
    },
    navto(path) {
      if (path) {
        this.$router.push("/NewsDetail/id=" + path);
      }
    },
    goback() {
      this.$router.push({
        //        path: '/search',
        path: `/Download`,
        query: { param: "news" },
      });
    },
    getBgImg() {
      let that = this;
      this.$axios
        .get("app/pagerimg/list")
        .then(function (response) {
          // console.log(response);
          var status = response.data.code;
          if (status === 0) {
            that.bgImg = response.data.page.list[2].img;
            // console.log(that.bgImg);
            // sessionStorage.setItem("input", "null");
          }
        })
        .catch((err) => console.log(err));
    },
    getDetail() {
      let that = this;
      let id = window.location.href.split("id=")[1];
      this.$axios
        .get("app/newspager/info/" + id)
        .then(function (response) {
          console.log(response);
          var status = response.data.code;
          if (status === 0) {
            that.Detail = response.data.newsPager;
            console.log(that.Detail);
            // sessionStorage.setItem("input", "null");
          }
        })
        .catch((err) => console.log(err));
    },
    getNews() {
      let that = this;
      this.$axios
        .get("app/newspager/list", {
          params: {
            page: 1,
            limit: 100,
          },
        })
        .then(function (response) {
          // console.log(response);
          var status = response.data.code;
          if (status === 0) {
            that.NewsList = response.data.page.list;
            console.log("news=" + that.NewsList.length);
            for (let i = 0; i < that.NewsList.length; i++) {
              let item = that.NewsList[i];
              if (item.id == window.location.href.split("id=")[1]) {
                if (i != 0) {
                  that.prveNewsTitle = that.NewsList[i - 1].title;
                  that.prveNewsId = that.NewsList[i - 1].id;
                } else {
                  that.prveNewsTitle = "无";
                }
                if (i < that.NewsList.length - 1) {
                  that.nextNewsTitle = that.NewsList[i + 1].title;
                  that.nextNewsId = that.NewsList[i + 1].id;
                } else {
                  that.nextNewsTitle = "无";
                }
                // break;
              }
            }
            // console.log(that.NewsList);
            // sessionStorage.setItem("input", "null");
          }
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.flex_container {
  display: flex;
  align-items: baseline;
  align-content: center;
}

.top_div {
  height: 100%;
  position: relative;
}

.home_banner {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  --swiper-pagination-color: #ec8938;
  object-fit: cover;

  div {
    width: 100%;
    height: 50vw;
    margin-left: auto;
    margin-right: auto;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}

.div_top_title {
  position: absolute;
  left: 20rem;
  bottom: 0;
  color: white;
  font-size: 3.6rem;
  font-family: medium;
  text-align: left;

  .p_title_sub {
    font-size: 4rem;
    font-family: bin_num_din;
  }

  .litter_line_top {
    margin: 1rem auto 3rem;
    background-color: var(--textWhiteColor40);
    box-shadow: 3px 3px 3px 0px rgba(0, 0, 0, 0.4);
    height: 1px;
    width: 6%;
  }
}

.html_div {
  width: 80%;
  margin: 5rem auto;

  .title {
    font-size: 2.6rem;
    font-family: medium;
    color: black;
  }

  .time {
    margin-top: 2rem;
    font-size: 1.4rem;
    font-family: light;
    color: #AFAFAF;
  }

  .line {
    margin: 5rem auto 0;
    width: 100%;
    height: 1px;
    background-color: #E4E4E4;
  }

  .news_more {
    margin: 1rem 2rem;
    display: flex;
    color: #9b9b9b;
    font-size: 1.6rem;
    font-family: light;
    justify-content: space-between;

    p {
      max-width: 30vw;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  .content {
    margin-top: 5rem;
    margin-bottom: 10rem;
    font-size: 1.6rem;
    font-family: light;
    color: black;
    text-align: left;

    img {
      width: 100%;
    }
  }
}

@media screen and (max-width: 1200px) {
  .top_div {
    padding-top: 60px;
  }

  .home_banner {
    height: 20rem;
  }

  .div_top_title {
    left: 2rem;
    bottom: 1rem;
    font-size: 2.6rem;

    .p_title_sub {
      font-size: 3rem;
    }
  }

  .html_div {
    width: 90%;

    .news_more {
      margin: 1rem 0;
    }
  }
}
</style>
